import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../../core/ScrollAnimation';
import CommonCircleList from '../../../../common-components/common-circle-list';

let list = {
    colorNumber: '#7927E0',
    list: [
        'сбор региональной семантики',
        'написание ТЗ для контента новых страниц и последующая проверка',
    ],
};

let listRight = {
    colorNumber: '#7927E0',
    list: [
        'анализ выдачи, написание ТЗ на создание новых региональных страниц',
        'написание рекомендаций по перелинковке новых страниц',
    ],
};

const SeoErrorsPages = () => {
    return (
        <div className="errors-pages">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <div className="errors-pages__content">
                    <div className="errors-pages__header">
                        Нет региональных страниц / поддоменов
                    </div>

                    <div className="errors-pages__text">
                        Если у сайта банка нет региональных страниц, они хуже ранжируются по
                        запросам +город. А, например кредиты ищут именно так (взять кредит в
                        Москве).
                    </div>

                    <div className="errors-pages__subtitle">Два способа реализации:</div>

                    <div className="errors-pages__blocks">
                        <div className="errors-pages__block">
                            <div className="errors-pages__block-main">
                                <span>Региональные страницы</span>
                                Используют большинство банков. Хорошо ранжируются в Google, но в
                                Яндексе уступают агрегаторам.
                            </div>
                        </div>
                        <div className="errors-pages__block">
                            <div className="errors-pages__block-main">
                                <span>Региональные поддомены</span>
                                Активно используются агрегаторами, но сложнее в реализации.
                            </div>
                        </div>
                    </div>

                    <div className="errors-pages__text">
                        Любой способ увеличит региональный целевой трафик и поможет фактически выйти
                        на новый уровень работы с регионами. Это критически важно, если у банка есть
                        филиалы по стране.
                    </div>

                    <div className="errors-pages__subtitle">
                        В рамках реализации этой точки роста необходимо:
                    </div>

                    <div className="errors-pages__lists">
                        <CommonCircleList CommonCircleList={list} />
                        <CommonCircleList CommonCircleList={listRight} />
                    </div>
                </div>
            </ScrollAnimation>
        </div>
    );
};

export default SeoErrorsPages;
